import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { ReactComponent as Calender } from '../../assets/icons/account-management/calender.svg';
import { ReactComponent as Plus } from '../../assets/icons/plus.svg';
import { PortalType } from '../../config/enum';
import { usePortal } from '../../contexts/PortalContext/PortalContext';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { setPageTitle } from '../../redux/slices/PageTitleSlice';
import MyButton from '../../shared-components/button/Button';
import TabToggle from '../../shared-components/tab-toggle/TabToggle';
import { permissionCheck } from '../../shared-functions/JWTDocodeFunction';

import Custom from './components/Custom';
import Global from './components/Global';
import Partner from './components/Partner';

/**
 * Component for displaying tariffs
 * @returns {React.JSX.Element} Tariff component
 */
function Tariff(): any {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [selectedTab, setSelectedTab] = useState<string>('Global');
  const { tariffCounts } = useAppSelector((state) => state.tariff);
  const { portalType, activePortal } = usePortal();
  const isPartnerPortal = portalType === PortalType.PARTNER || activePortal === PortalType.PARTNER;

  useEffect(() => {
    dispatch(
      setPageTitle({
        title: 'Charging Tariffs',
      }),
    );
  }, [dispatch]);

  return (
    <div className="tariff-page-wrapper">
      <div className="tariff-header">
        <TabToggle
          tabs={[
            { label: 'Global', value: 'Global', count: tariffCounts?.global || 0 },
            { label: 'Custom', value: 'Custom', count: tariffCounts?.custom || 0 },
            ...(!isPartnerPortal
              ? [{ label: 'Partner', value: 'Partner', count: tariffCounts?.partnerCreate || 0 }]
              : []),
          ]}
          defaultTab="Global"
          onChange={(tab) => setSelectedTab(tab)}
        />
        <div className="add-tariff-button">
          <MyButton
            label="Tariff Calculator"
            buttonType="primary-outline"
            onClickFunc={() => navigate('/ev-admin/tariffs/calculator')}
            svgIcon={<Calender />}
            disableButton={
              !permissionCheck('partnerTariffCalculation') &&
              !permissionCheck('cpoTariffCalculation')
            }
          />
          <MyButton
            label="Add Tariff"
            buttonType="submit"
            onClickFunc={() => navigate('/ev-admin/tariffs/add-tariff')}
            svgIcon={<Plus />}
            disableButton={!permissionCheck('partnerTariffAdd') && !permissionCheck('cpoTariffAdd')}
          />
        </div>
      </div>
      <div className="tariff-table-wrapper">
        {selectedTab === 'Global' && <Global />}
        {selectedTab === 'Custom' && <Custom />}
        {!isPartnerPortal && selectedTab === 'Partner' && <Partner />}
      </div>
    </div>
  );
}

export default Tariff;
